import { render, staticRenderFns } from "./ECard.vue?vue&type=template&id=5d65585e&scoped=true&"
import script from "./eCard.ts?vue&type=script&lang=ts&"
export * from "./eCard.ts?vue&type=script&lang=ts&"
import style0 from "./ECard.vue?vue&type=style&index=0&id=5d65585e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d65585e",
  null
  
)

export default component.exports